import { render, staticRenderFns } from "./FacetsFilters.vue?vue&type=template&id=4918c52c&"
import script from "./FacetsFilters.vue?vue&type=script&lang=js&"
export * from "./FacetsFilters.vue?vue&type=script&lang=js&"
import style0 from "./FacetsFilters.vue?vue&type=style&index=0&id=4918c52c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports